import React from 'react'

// Модалка подтверждения на кнопке «Домой» в формах карточки
export const HomeConfirm = ({ open, onSave, onExit }) => {
  if (!open) return null
  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        background: "rgba(0,0,0,0.55)",
        zIndex: 9999,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <div className="card white" style={{ padding: "2rem", maxWidth: 420, margin: "1rem" }}>
        <span className="card-title">Внимание</span>
        <p style={{ marginTop: "0.5rem" }}>Текущие данные не будут сохранены.</p>
        <div style={{ display: "flex", gap: "1rem", justifyContent: "flex-end", marginTop: "1.5rem" }}>
          <button className="btn blue" onClick={onSave}>Сохранить</button>
          <button className="btn grey lighten-1 black-text" onClick={onExit}>Выйти</button>
        </div>
      </div>
    </div>
  )
}